import * as React from 'react';

import { LandingPageV2Props } from 'cms';
import { CacheSafeGetServerSideProps } from 'declarations/shared/serverSideProps';
import { WithRouterProps } from 'next/dist/client/with-router';
import { withRouter } from 'next/router';
import LandingPageV2Layout, {
  getLandingpageV2ServerSideProps,
} from 'pages/shared/LandingPageV2Layout';

import ResetPasswordFormPage from '../components/account/ResetPasswordFormPage';
import ReduxWrapper from '../components/shared/ReduxWrapper';

export const getServerSideProps: CacheSafeGetServerSideProps<LandingPageV2Props> = async (
  context,
) => {
  //Setting the Slug to fetch the landing Page from Contentful .
  context.params = {
    slug: 'reset-password',
  };

  context.query.slug = 'reset-password';
  return getLandingpageV2ServerSideProps(context);
};

export default withRouter(
  (context: React.PropsWithChildren<WithRouterProps & LandingPageV2Props>) => {
    return (
      <ReduxWrapper>
        <LandingPageV2Layout {...context}>
          <ResetPasswordFormPage {...context.router.query} />
        </LandingPageV2Layout>
      </ReduxWrapper>
    );
  },
);
